import { axiosInstanceWithToken } from 'utils/axios';
import { IProductResource } from '../../server/types';

export const fetchProductLink = async (productName: string) =>
  axiosInstanceWithToken().get<{ products: IProductResource[] }>(`/product-links/${productName}`);
